// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explore-card {
    background-color: #1e102d;
    color: white;
    padding: 2rem;
    border: 1px solid #9256E8;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    width: 550px;
    height: 531px;
}

.explore-card .badge-wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}

.explore-card .badge-wrap .subscription-badge {
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    background-color: #9256E8;
    border-radius: 74px;
    padding: 10px 14px;
}

.explore-card .content-wrap {
    min-height: 160px;
}

.explore-card .content-wrap .title {
    color: #FFF;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 153%;
    font-family: "Inter", sans-serif;
    margin-bottom: 0px;
    text-align: left;
}

.explore-card .sub-title {
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    padding-bottom: 13px;
}

.explore-card .price {
    color: #FFF;
    font-size: 32px;
    font-style: normal;
    font-weight: 800;
    line-height: 38.4px;
    font-family: "Inter", sans-serif;
    text-align: left;
}

.explore-card .description {
    color: #FFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    padding-top: 44px;
    margin-bottom: 100px;
}

.explore-card .sub-from {
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

@media(max-width: 768px) {
    .explore-card {
        padding: 20px;
    }

    .explore-card .badge-wrap .subscription-badge {
        font-size: 15px;
    }

    .explore-container .title {
        font-size: 25px !important;
        text-align: left;
        padding-bottom: 0px;
        margin-bottom: 0px;
        line-height: 153%;
        font-family: "Inter", sans-serif;
    }

    .explore-card .sub-title {
        font-size: 15px;
        text-align: left;
        padding: 0px 8px;
    }

    .explore-card .price {
        font-size: 20px;
        text-align: left;

    }

    .explore-card .description {
        font-size: 15px;
        text-align: left;
        margin-bottom: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ExploreCard/ExploreCard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;;IAEpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;AACJ","sourcesContent":[".explore-card {\n    background-color: #1e102d;\n    color: white;\n    padding: 2rem;\n    border: 1px solid #9256E8;\n    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    width: 550px;\n    height: 531px;\n}\n\n.explore-card .badge-wrap {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n}\n\n.explore-card .badge-wrap .subscription-badge {\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n    background-color: #9256E8;\n    border-radius: 74px;\n    padding: 10px 14px;\n}\n\n.explore-card .content-wrap {\n    min-height: 160px;\n}\n\n.explore-card .content-wrap .title {\n    color: #FFF;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 153%;\n    font-family: \"Inter\", sans-serif;\n    margin-bottom: 0px;\n    text-align: left;\n}\n\n.explore-card .sub-title {\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n    padding-bottom: 13px;\n}\n\n.explore-card .price {\n    color: #FFF;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 38.4px;\n    font-family: \"Inter\", sans-serif;\n    text-align: left;\n}\n\n.explore-card .description {\n    color: #FFF;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 28px;\n    padding-top: 44px;\n    margin-bottom: 100px;\n}\n\n.explore-card .sub-from {\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n@media(max-width: 768px) {\n    .explore-card {\n        padding: 20px;\n    }\n\n    .explore-card .badge-wrap .subscription-badge {\n        font-size: 15px;\n    }\n\n    .explore-container .title {\n        font-size: 25px !important;\n        text-align: left;\n        padding-bottom: 0px;\n        margin-bottom: 0px;\n        line-height: 153%;\n        font-family: \"Inter\", sans-serif;\n    }\n\n    .explore-card .sub-title {\n        font-size: 15px;\n        text-align: left;\n        padding: 0px 8px;\n    }\n\n    .explore-card .price {\n        font-size: 20px;\n        text-align: left;\n\n    }\n\n    .explore-card .description {\n        font-size: 15px;\n        text-align: left;\n        margin-bottom: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
